import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
  console.log({ props });
  const { id, format, data, templateName } = props;

  const timeouts = [];

  const timeline = anime.timeline();

  const templateDuration = getTemplateDurationOveride({
    apiSetup: props?.apiSetup,
    tournamentId: props?.data?.event?.competitionId,
    fallback:
      _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
    templateName,
    event: data?.event,
  });

  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );

  anime({
    targets: [`#${id} .qatar-logo`],
    duration: 800,
    easing: "easeOutQuint",
    scale: [0, 1],
    opacity: [1, 1],
    delay: 200,
  });

  anime({
    targets: [`#${id} .left-block-side`],
    duration: 800,
    easing: "easeOutQuint",
    translateX: [-2000, 0],
    opacity: [0, 1],
    delay: 500,
  });

  anime({
    targets: [`#${id} .custom-background`],
    duration: 14000,
    easing: "linear",
    scale: [1, 1.35],
    delay: 0,
  });

  anime({
    targets: [`#${id} .right-block-side`],
    duration: 800,
    easing: "easeOutQuint",
    translateX: [2000, 0],
    opacity: [0, 1],
    delay: 800,
  });

  anime({
    targets: [`#${id} .right-block-content-side`],
    duration: 800,
    easing: "easeOutQuint",
    translateX: [-2000, 0],
    opacity: [0, 1],
    delay: 800,
  });

  anime({
    targets: [`#${id} .top-block-content-side`],
    duration: 800,
    easing: "easeOutQuint",
    translateY: [2000, 0],
    opacity: [0, 1],
    delay: 800,
  });

  anime({
    targets: [`#${id} .bottom-block-content-side`],
    duration: 800,
    easing: "easeOutQuint",
    translateY: [-2000, 0],
    opacity: [0, 1],
    delay: 800,
  });

  return {
    timeline: timeline,
    timeouts: timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
